export default __webpack_public_path__ + "static/media/spotlight.70e48f90.svg";